export default "__VITE_ASSET__Cw88$SzT__"